@if (this.PrintAllowed && !loading) {
  <div class="packing-list-page-container">
    <div class="packing-list-container" style="position: relative;">
      @if (ActiveDocumentVersion) {
        <div
          style="position: absolute; right: 5px; top: 5px; font-size: 10px; text-align: right; line-height: 1.2;">
          <span>{{ActiveDocumentVersion.FormatNo}}, Rev No. {{ActiveDocumentVersion.VersionNo}}</span>
        </div>
      }
      <!-- Company Header -->
      <div class="company-header">
        <div class="company-name">{{this.Company.CompanyName}}</div>
        <div class="company-addresses">
          <span><b>Head Office:</b> {{this.Company.HeadOfficeAddress}}</span> |
          <span><b>Factory:</b> {{this.Company.FactoryAddress}}</span>
        </div>
      </div>
      <!-- Document Title -->
      <div class="document-title">
        <b>DETAILED PACKING LIST - OutPass No.: {{printData.OutpassDetails.OutpassNumber}}</b>
      </div>
      <!-- OutPass Summary -->
      <div class="outpass-summary">
        <table class="summary-table">
          <tr>
            <td><b>OutPass To:</b></td>
            <td>{{printData.OutpassDetails.OutpassTo}}</td>
            <td><b>OutPass Date:</b></td>
            <td>{{printData.OutpassDetails.OutpassDate | DatetimeConverter}}</td>
          </tr>
          @if (sentByDisplay) {
            <tr>
              <td><b>Sent by:</b></td>
              <td colspan="3">{{sentByDisplay}}</td>
            </tr>
          }
          <tr>
            <td><b>OutPass Type:</b></td>
            <td>{{printData.OutpassDetails.OutpassType}}</td>
            <td><b>Purpose:</b></td>
            <td>{{printData.OutpassDetails.Purpose}}</td>
          </tr>
          <tr>
            <td><b>Status:</b></td>
            <td>{{printData.OutpassDetails.Status}}</td>
            <td><b>Processing Method:</b></td>
            <td>{{printData.OutpassDetails.CreateMode}}</td>
          </tr>
        </table>
      </div>
      <!-- Packing Summary -->
      @if (printData.Summary) {
        <div class="packing-summary">
          <h3>Packing Summary</h3>
          <div class="summary-grid">
            <div class="summary-item">
              <span class="label">Total Products:</span>
              <span class="value">{{printData.Summary.TotalProducts}}</span>
            </div>
            <div class="summary-item">
              <span class="label">Total Labels:</span>
              <span class="value">{{printData.Summary.TotalLabels}}</span>
            </div>
            <div class="summary-item">
              <span class="label">Manual Items:</span>
              <span class="value">{{printData.Summary.TotalManualItems}}</span>
            </div>
            <div class="summary-item">
              <span class="label">Barcode Items:</span>
              <span class="value">{{printData.Summary.TotalBarcodeItems}}</span>
            </div>
            <div class="summary-item full-width">
              <span class="label">Packaging Breakdown:</span>
              <span class="value">{{getPackagingSummary()}}</span>
            </div>
          </div>
        </div>
      }
      <!-- Detailed Item Listing by Unit Groups -->
      @for (unitGroup of printData.UnitGroups; track unitGroup) {
        <div class="unit-section">
          <div class="unit-header">
            <h3>{{unitGroup.UnitType}} Items</h3>
            <div class="unit-totals">
              Total: {{unitGroup.TotalQuantity | number:'1.2-2'}} {{unitGroup.UnitType}} |
              Amount: ₹{{unitGroup.TotalAmount | number:'1.2-2'}} |
              Labels: {{unitGroup.TotalLabels}}
            </div>
          </div>
          <!-- Products within this unit group -->
          @for (product of unitGroup.Products; track product) {
            <div class="product-section">
              <div class="product-header">
                <h4>{{product.ProductName}}</h4>
                <div class="product-summary">
                  Qty: {{product.TotalQuantity | number:'1.2-2'}} {{unitGroup.UnitType}} |
                  Amount: ₹{{product.TotalAmount | number:'1.2-2'}} |
                  Labels: {{product.LabelCount}}
                  @if (product.PackagingBreakdown) {
                    <span> | Packaging: {{product.PackagingBreakdown}}</span>
                  }
                </div>
              </div>
              <!-- Detailed item table -->
              <table class="items-table">
                <thead>
                  <tr>
                    <th style="width: 8%;">S.No</th>
                    <th style="width: 18%;">Serial Number</th>
                    <th style="width: 15%;">Short Code</th>
                    <th style="width: 12%;">Batch No</th>
                    <th style="width: 10%;">Quantity</th>
                    <th style="width: 12%;">Packaging</th>
                    <th style="width: 15%;">Location</th>
                    <th style="width: 10%;">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of product.Items; track item; let i = $index) {
                    <tr [class.manual-item]="item.EntryType === 'Manual'"
                      [class.barcode-item]="item.EntryType === 'Barcode'">
                      <td>{{i+1}}</td>
                      <td>
                        @if (item.EntryType === 'Barcode' && item.SerialNumbers.length > 0) {
                          <div>
                            @for (serial of item.SerialNumbers; track serial) {
                              <div class="serial-number">
                                {{serial}}
                              </div>
                            }
                          </div>
                        }
                        @if (item.EntryType === 'Manual') {
                          <div class="manual-entry">
                            Manual Entry
                          </div>
                        }
                      </td>
                      <td>{{getShortCode(item)}}</td>
                      <td>{{item.BatchNo || 'N/A'}}</td>
                      <td>{{item.Quantity | number:'1.2-2'}}</td>
                      <td>
                        @if (item.PackagingUnits.length > 0) {
                          <div>
                            @for (pkg of item.PackagingUnits; track pkg) {
                              <div>{{pkg}}</div>
                            }
                          </div>
                        }
                        @if (item.PackagingUnits.length === 0) {
                          <div>N/A</div>
                        }
                      </td>
                      <td>
                        <div class="location">
                          <div class="store">{{item.StoreName}}</div>
                          <div class="rack">{{item.RackName}}</div>
                        </div>
                      </td>
                      <td>₹{{item.TotalAmount | number:'1.2-2'}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      }
      <!-- Footer -->
      <div class="footer">
        <table class="footer-table">
          <tr>
            <td class="prepared-by">
              <div><b>PREPARED BY:</b></div>
              <div class="signature-name">{{printData.OutpassDetails.AddedBy}}</div>
            </td>
            <td class="verified-by">
              <div><b>VERIFIED BY:</b></div>
              <div class="signature-space"></div>
              <div class="signature-label">Quality Control</div>
            </td>
            <td class="approved-by">
              <div><b>APPROVED BY:</b></div>
              <div class="signature-space"></div>
              <div class="signature-label">Authorized Signatory</div>
            </td>
          </tr>
        </table>
        <div class="powered-by">Detailed Packing List</div>
        <app-print-footer [audience]="'external'"></app-print-footer>
      </div>
    </div>
  </div>
}

<!-- Loading state -->
@if (loading) {
  <div class="loading-container">
    <div class="loading-spinner">Loading packing list data...</div>
  </div>
}

<!-- Not allowed message -->
@if (!PrintAllowed && !loading) {
  <div class="not-allowed">
    <h3>Print Not Allowed</h3>
    <p>This OutPass must be pending approval, approved or gated out to generate a packing list.</p>
  </div>
}